/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkflowDefinition } from './WorkflowDefinition';
import {
    WorkflowDefinitionFromJSON,
    WorkflowDefinitionFromJSONTyped,
    WorkflowDefinitionToJSON,
} from './WorkflowDefinition';

/**
 * 
 * @export
 * @interface ListWorkflowDefinitionsResponseBody
 */
export interface ListWorkflowDefinitionsResponseBody {
    /**
     * 
     * @type {Array<WorkflowDefinition>}
     * @memberof ListWorkflowDefinitionsResponseBody
     */
    items: Array<WorkflowDefinition>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListWorkflowDefinitionsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListWorkflowDefinitionsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListWorkflowDefinitionsResponseBody interface.
 */
export function instanceOfListWorkflowDefinitionsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListWorkflowDefinitionsResponseBodyFromJSON(json: any): ListWorkflowDefinitionsResponseBody {
    return ListWorkflowDefinitionsResponseBodyFromJSONTyped(json, false);
}

export function ListWorkflowDefinitionsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWorkflowDefinitionsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(WorkflowDefinitionFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListWorkflowDefinitionsResponseBodyToJSON(value?: ListWorkflowDefinitionsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(WorkflowDefinitionToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

